import { tns } from 'tiny-slider/src/tiny-slider';

export default class RelatedConstructionNumberSlider {
  constructor(element) {
    this.slider = tns({
      container: element.querySelector('.js-slider-items'),
      autoWidth: false,
      loop: false,
      gutter: 12,
      center: false,
      speed: 200,
      controlsContainer: element.querySelector('.js-slider-arrows'),
      nav: false,
      responsive: {
        1025: {
          items: 3
        },
        768: {
          items: 2
        },
        375: {
          items: 1
        }
      }
    });

    this.slider.events.on('transitionEnd', (info) => {
      info.slideItems[info.indexCached].classList.remove(
        'is--current'
      );

      info.slideItems[info.index].classList.add(
        'is--current'
      );
    });
  }
}
